module.exports = __webpack_public_path__ + "static/media/mania_item_complete.32659263.png";